import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import female from '../../assets/icon/female.svg';
import male from '../../assets/icon/female.svg';
import checkAlt from '../../assets/icon/checkAlt.svg';
import times from '../../assets/icon/times.svg';
import edit from '../../assets/icon/edit.svg';

import Button from './button';

const Article = Styled.article`
max-width: 50rem;
border: solid 1px ${color.secondaryAlt};
background: ${color.white};
border-radius: 1rem;
padding: 2rem 2rem;
`;

const ArticleHeader = Styled.header`
width: 100%;
color: ${color.primary};
display: flex;
align-items:center;
justify-content: space-between;
text-align:center;
`;

const ArticleHeaderFirst = Styled.div`
display: flex;
align-items:center;
justify-content: space-between;
text-align:left;
`;

const ArticleAvatar = Styled.figure`
display: block;
height: 6rem;
width: 6rem;
margin-right: 1rem;
border-radius: 100rem;
background: ${color.primary};
img{width: 100%;height:100%;object-fit: cover};
overflow:hidden;
`;
const ArticleName = Styled.h4`
font-size: 2rem;
text-transform: capitalize;
line-height: 1;
`;
const ArticleBreed = Styled.p`
font-weight: 300;
text-transform: capitalize;
line-height: 1;
`;

const ArticleBody = Styled.div`
margin-top: 3rem;
`;

const ArticleCardWrapper = Styled.div`
display: grid;
grid-template-columns:repeat(4, 1fr);
`;

const ArticleCard = Styled.div`
display:flex;
flex-direction: column;
align-items:center;
justify-content:center;
padding: 1rem 0;
border:solid 1px ${color.lightAlt};
color: ${color.primaryAlt};
font-weight: 300;
font-size: 2.4rem;
em{
font-weight: 600;
font-size: 1.5rem;
font-style:normal
};`;

const PetProfileCondensed = ({
  name,
  breed,
  gender,
  pound,
  age,
  spayed,
  image,
}) => {
  return (
    <Article>
      <ArticleHeader>
        <ArticleHeaderFirst>
          <ArticleAvatar>
            <img src={image} alt="" />
          </ArticleAvatar>
          <div>
            <ArticleBreed>Service for</ArticleBreed>
            <ArticleName>{breed}</ArticleName>
          </div>
        </ArticleHeaderFirst>
        <Button type="light" icon={edit} text="Edit" />
      </ArticleHeader>

      <ArticleBody>
        <ArticleCardWrapper>
          <ArticleCard>
            {gender === 'male' ? (
              <React.Fragment>
                <img src={male} alt="" />
                <em>Male</em>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <img src={female} alt="" />
                <em>Female</em>
              </React.Fragment>
            )}
          </ArticleCard>
          <ArticleCard>
            {age}
            <em>Years</em>
          </ArticleCard>
          <ArticleCard>
            {spayed ? (
              <img src={checkAlt} alt="" />
            ) : (
              <img src={times} alt="" />
            )}
            <em>Spayed</em>
          </ArticleCard>
          <ArticleCard>
            {pound}
            <em>Pounds</em>
          </ArticleCard>
        </ArticleCardWrapper>
      </ArticleBody>
    </Article>
  );
};

export default PetProfileCondensed;
